import { Media, Colors } from 'enums';
import styled, { css } from 'styled-components';
import { Text } from '../Text';

type IProps = {
  isOnPageWithTabs?: boolean;
};

export const BackLinkIcon = styled.img`
  transform: rotate(90deg);
  width: 24px;
  height: 24px;

  @media ${Media.tablet} {
    width: 20px;
    height: 20px;
  }

  @media ${Media.notebook} {
    width: 24px;
    height: 24px;
  }
  @media ${Media.desktop} {
    width: 24px;
    height: 26px;
  }
`;

export const BackLinkWrapper = styled.div<IProps>`
  position: ${({ isOnPageWithTabs }) =>
    isOnPageWithTabs ? 'relative' : 'absolute'};
  top: 0px;
  left: 0px;
  display: flex;
  max-width: max-content;
  cursor: pointer;

  ${({ isOnPageWithTabs }) => {
    if (!isOnPageWithTabs) {
      return css`
        @media ${Media.mobile} {
          top: 94px;
          left: 20px;
        }

        @media ${Media.tablet} {
          top: 95px;
          left: 40px;
        }

        @media ${Media.notebook} {
          top: 153px;
          left: 75px;
        }

        @media ${Media.desktop} {
          top: 152px;
          left: 150px;
        }
      `;
    }

    return '';
  }}

  &:active {
    filter: brightness(0) saturate(100%) invert(82%) sepia(18%) saturate(5217%)
      hue-rotate(2deg) brightness(111%) contrast(101%);
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: -25%;
    width: 100%;
    height: 100%;
    padding: 0.5em;
  }
`;

export const BackLinkText = styled(Text)`
  display: none;

  @media ${Media.tablet} {
    display: block;
    margin-left: 6px;
    border-bottom: 1px solid ${Colors.yellow1};
    padding-top: 2px;
    padding-bottom: 2px;
  }

  @media ${Media.notebook} {
    margin-left: 2px;
  }
`;
